<template>
  <div style="margin-bottom: 60px;">
    <HeadTitle :url="url"></HeadTitle>
    <div class="systemPersonDetail">
      <div class="myInfoBox">
        <div class="row">
          <div class="title">用户名</div>
          <div class="value">
            <van-field v-model="user" autocomplete="off" placeholder="请输入" arrow-direction="" />
          </div>
        </div>
        <div class="row">
          <div class="title">密码</div>
          <div class="value">
            <van-field type="password" autocomplete="off" v-model="pass" placeholder="请输入" />
          </div>
        </div>
        <div class="row">
          <div class="title">确认密码</div>
          <div class="value">
            <van-field type="password" v-model="password" autocomplete="off" placeholder="请输入" />
          </div>
        </div>

        <div class="row">
          <div class="title">姓名</div>
          <div class="value">
            <van-field v-model="username" autocomplete="off" placeholder="请输入" />
          </div>
        </div>
        <div class="row" style="height: 90px;">
          <div class="title">头像</div>
          <div class="value">
            <div class="touxiang">
              <van-uploader v-model="fileList" :after-read="afterRead" :max-count="1" :max-size="10 * 1024 * 1024"
                :before-read="beforeRead" accept="image/*" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="title">状态</div>
          <div class="value">
            <van-radio-group v-model="status" direction="horizontal">
              <van-radio name="1">正常</van-radio>
              <van-radio name="2">关闭</van-radio>
            </van-radio-group>
          </div>
        </div>

        <div class="row">
          <div class="title">隶属用户组</div>
          <div class="value">
            <van-field v-model="group_name" is-link readonly label="" placeholder="请选择隶属用户组" autocomplete="off"
              @click="clickUser" />
          </div>
        </div>
        <div style="z-index: 8">
          <van-popup v-model="showUserGroup" round position="bottom">
            <van-picker title="隶属用户组" show-toolbar :columns="groups" @cancel="showUserGroup = false"
              @confirm="okUserGroup" />
          </van-popup>


        </div>

        <div class="labelBox">
          <div class="labelTitle">关联PGC账号</div>
          <div>
            <van-checkbox-group v-model="pgc_uid_list" direction="horizontal">
              <van-checkbox v-for="item in pgcList" :key="item.pgc_uid" :name="item.pgc_uid" class="checkItem">{{
                item.nickname }}</van-checkbox>
            </van-checkbox-group>
          </div>
        </div>
      </div>
      <div class="btnBoottom">
        <div class="operationBtn">
          <div @click="cancel" class="btn1">取消</div>
          <div @click="confrim" class="btn2">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { Toast, Dialog } from "vant";
import { groupListApi, pgcListAPI } from "@/api/commonSelect";
import { addSysUserAPI } from "@/api/systemPerson";
import HeadTitle from "../../components/HeadTitle";
import { uploaduserImageAPI } from "@/api/systemPerson";
import { Toast } from "vant";
export default {
  name: "AddSystemPerson",
  components: {
    HeadTitle,
  },
  data() {
    return {
      url: "/systemPerson",
      user: "",
      admin_picture: "",
      radio: 0,
      pass: "",
      username: "",
      password: "",
      status: "1", // 状态,
      group_id: "",
      group_name: "",
      showUserGroup: false,
      pgcInputWidth: "120px",
      pgc_uid_list: [], // 关联PGC账号(check)
      fieldValue: "", // 关联PGC账号
      showArticlePgc: false,
      checkedValue: [],
      groups: [],
      pgcList: [],
      fileList: [],
      loading: false,
    };
  },
  computed: {
    admin_id() {
      let admin_id = this.$route?.query?.admin_id || "";
      return admin_id;
    },
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (
          (oldVal?.name === "SystemPerson" || oldVal === undefined) &&
          !this.admin_id
        ) {
          this.getPgcList();
          this.getGroupList();
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 返回布尔值
    beforeRead(file) {
      console.log(file);
      if (
        file.type !== "image/jpeg" &&
        file.type !== "image/jpg" &&
        file.type !== "image/png" &&
        file.type !== "image/gif" &&
        file.type !== "image/psd" &&
        file.type !== "image/tif" &&
        file.type !== "image/bmp"
      ) {
        Toast.fail("上传的文件格式只支持图片格式");
        return false;
      }
      return true;
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      console.log(file);
      this.uploadImg();
    },
    uploadImg() {
      if (this.fileList?.length) {
        this.loading = true;
        this.fileList[0].status = "uploading";
        this.fileList[0].message = "上传中...";
        let data = new FormData();
        const file = this.fileList?.[0].file;
        data.append("file", file);
        uploaduserImageAPI(data)
          .then((res) => {
            const uploadResult = JSON.parse(res.data);
            if (uploadResult.status === 1) {
              console.log(uploadResult, "图片上传结果");
              const imgUrl = uploadResult.src || "";
              this.loading = false;
              this.fileList[0].status = "done";
              Toast.success("头像上传成功");
              this.admin_picture = imgUrl;
            }
          })
          .finally(() => {
            this.loading = false;
            this.fileList[0].status = "done";
          });
      } else {
        Toast.fail("请先点击上传");
      }
    },
    clickUser() {
      this.showUserGroup = true;
    },
    // 获取用户组列表
    getGroupList() {
      const params = {
        action: "select",
        page: 1,
        limit: 30,
      };
      groupListApi(null, params).then((res) => {
        if (res.data.code === 0) {
          res.data.data.map((item) => {
            if (item.group_name.includes("移动端")) {
              this.groups.push({ text: item.group_name, value: item.group_id });
            }
          })
        }
      });
    },
    // 获取pgc列表
    getPgcList() {
      const params = {
        curr: 1,
        nums: 50,
      };
      pgcListAPI(params).then((res) => {
        if (res.data.code === 0) {
          this.pgcList = res.data.data || [];
        }
      });
    },

    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
    // 关联PGC账号
    okPgc() {
      let value = [];
      let values = [];
      for (let i = 0; i < this.checkedValue.length; i++) {
        if (value.indexOf(this.checkedValue[i].specificEventId) === -1) {
          //选中数据如果不包含添加进新数组
          value.push(this.checkedValue[i].specificEventId);
          values.push(this.checkedValue[i].specificEventName);
        } else if (value.indexOf(this.checkedValue[i].specificEventId) > -1) {
          //包含则删除
          let index = value.indexOf(this.checkedValue[i].specificEventId);
          let indexs = values.indexOf(this.checkedValue[i].specificEventName);
          value.splice(index, 1);
          values.splice(indexs, 1);
        }
      }
      this.activeIndexList = value;
      this.name = values.toString();
      this.fieldValue = this.name;
      let keylength = Object.values(this.activeIndexList)?.length;
      this.pgcInputWidth = keylength ? keylength * 80 + "px" : "80px";

      // this.fieldValue = this.caseFieldValue(this.radio);
      this.showArticlePgc = false;
    },
    caseFieldValue(state) {
      const stateList = {
        a: "待审核",
        b: "通过",
        c: "不通过",
      };
      return stateList[state] ? stateList[state] : "";
    },

    // 确认隶属用户组
    okUserGroup(data) {
      this.group_name = data.text;
      this.group_id = data.value;
      this.showUserGroup = false;
    },
    cancel() {
      this.$router.push({ path: "/systemPerson" });
    },
    volidRule() {
      if (!this.user) {
        Toast.fail("用户名不能为空");
        return false;
      }
      let reg = /^\w*[a-zA-Z]+\w*$/;

      if (!reg.test(this.user)) {
        Toast.fail("用户名不能全为数字");
        return false;
      }
      if (!this.pass) {
        Toast.fail("密码不能为空");
        return false;
      }
      if (!this.password) {
        Toast.fail("确认密码不能为空");
        return false;
      }
      if (this.pass !== this.password) {
        Toast.fail("密码和确认密码必须保持一致");
        return false;
      }
      if (!this.username) {
        Toast.fail("姓名不能为空");
        return false;
      }
      if (!this.admin_picture) {
        Toast.fail("头像不能为空");
        return false;
      }
      if (!this.status) {
        Toast.fail("状态不能为空");
        return false;
      }
      if (!this.group_id) {
        Toast.fail("隶属用户组不能为空");
        return false;
      }
      return true;
    },
    async confrim() {
      const valide = await this.volidRule();
      if (valide) {
        const data = {
          user: this.user,
          username: this.username,
          admin_picture: this.admin_picture,
          pass: this.pass,
          password: this.password,
          file: "",
          status: this.status, // 状态
          group_id: this.group_id, // 隶属用户组
          pgc_uid_list: this.pgc_uid_list.toString(), // 关联pgc账号
        };
        // 添加人员
        addSysUserAPI(data).then((res) => {
          if (res.data.status === 1) {
            Toast.success("新增用户成功");
            this.$router.push({ path: "/systemPerson" });
          } else {
            Toast.fail(res.data.info);
          }
        });
      }
    },
  },
};
</script>
<style scoped lang="less">
.systemPersonDetail {
  margin: 100px 18px 40px 18px;

  .myInfoBox {
    margin: 0px 12px;

    .row {
      padding: 12px 0px;
      display: flex;
      justify-content: space-between;
      height: 100px;
      //   width: 100%;
      align-items: center;
      border-bottom: 0.1px solid #dcdcdc;
      font-size: 30px;

      // color: #969799;
      // /deep/ .van-cell {
      //   padding: 0px 0px;
      // }
      /deep/.van-field__control {
        text-align: right;
      }
    }

    /* 弹框层样式 */
    .bottomModal {
      display: flex;
      height: 100px;
      align-items: center;
      justify-content: center;
      margin-bottom: 30px;
      font-size: 36px;
    }

    .checkboxItem {
      height: 70px;
      line-height: 70px;
      font-size: 30px;
    }

    .radioItem {
      height: 120px;
      line-height: 120px;
      font-size: 30px;
    }

    .labelBox {
      margin: 16px 0px;
      font-size: 30px;

      .labelTitle {
        height: 50px;
        line-height: 50px;
      }

      .checkItem {
        width: 45%;
        margin: 12px 8px;
      }
    }

    .touxiang {
      display: flex;

      .image {
        width: 80px;
        height: 80px;
        border-radius: 50%;
      }

      .icon {
        line-height: 80px;
      }
    }
  }

  .btnBoottom {
    position: fixed;
    left: 12px;
    right: 0;
    bottom: 40px;
    // bottom: 36px;
    z-index: 5;
    width: 100%;
    height: 80px;

    .operationBtn {
      display: flex;
      line-height: 80px;
      justify-content: space-around;

      div {
        font-size: 30px;
        width: 40%;
        text-align: center;
        border: 1px solid rgb(72, 113, 192);
        margin: 0px 12px;
      }

      .btn1 {
        background: white;
        color: rgb(72, 113, 192);
      }

      .btn2 {
        background: rgb(72, 113, 192);
        color: white;
      }
    }
  }
}
</style>